import { useEffect, useRef } from 'react'

import slide01 from './assets/images/slide-01.png'
import slide02 from './assets/images/slide-02.png'
import slide03 from './assets/images/slide-03.png'
import slide04 from './assets/images/slide-04.png'
import slide05 from './assets/images/slide-05.png'

import c from './assets/sass/slider.module.scss'

const slides = [slide01, slide02, slide03, slide04, slide05]

const loopSlides = [
    ...slides,
    ...slides,
    ...slides,
    ...slides,
    ...slides
]

const Slider = () => {
    const viewportRef = useRef(null)
    const trackRef = useRef(null)

    useEffect(() => {
        const viewport = viewportRef.current
        const track = trackRef.current

        if (!viewport || !track) return

        let speed = 55
        let previousTime = performance.now()
        let inertiaVelocity = 0

        const reducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        )

        const clamp = (value, min = 0, max = 1) =>
            Math.max(min, Math.min(max, value))

        const getGap = () =>
            Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0

        const getStride = () => {
            const first = track.firstElementChild
            if (!first) return 0
            return first.offsetWidth + getGap()
        }

        let offset = 0

        const normalizeOffset = () => {
            const stride = getStride()
            if (!stride) return

            const resetDistance = stride * slides.length

            while (offset <= -resetDistance * 3) {
                offset += resetDistance
            }

            while (offset >= -resetDistance) {
                offset -= resetDistance
            }
        }

        const renderTrack = () => {
            normalizeOffset()
            track.style.transform = `translate3d(${offset}px,0,0)`
        }

        const updateEffects = () => {
            const bounds = viewport.getBoundingClientRect()

            const leftDistance = Math.min(190, bounds.width * 0.31)
            const rightDistance = Math.min(150, bounds.width * 0.24)

            Array.from(track.children).forEach((slide, index) => {
                const center =
                    bounds.left +
                    offset +
                    slide.offsetLeft +
                    slide.offsetWidth / 2

                const leftProgress = clamp(
                    (center - bounds.left) / leftDistance
                )

                const rightProgress = clamp(
                    (bounds.right - center) / rightDistance
                )

                const edgeVisibility = Math.min(
                    leftProgress,
                    rightProgress
                )

                const leaving = 1 - leftProgress
                const entering = 1 - rightProgress

                const leftScale = 1 - leaving * 0.25
                const rightScale = 1 - entering * 0.16

                const scale = Math.min(leftScale, rightScale)
                const tuck = leaving * 32

                slide.style.opacity = edgeVisibility
                slide.style.transform = `translate3d(${tuck}px,0,0) scale(${scale})`
                slide.style.zIndex = `${100 + (index % slides.length)}`
            })
        }

        let raf

        const animate = (time) => {
            const delta = Math.min((time - previousTime) / 1000, 0.05)
            previousTime = time

            if (!reducedMotion.matches) {
                if (Math.abs(inertiaVelocity) > 8) {
                    offset += inertiaVelocity * delta
                    inertiaVelocity *= Math.exp(-6 * delta)
                } else {
                    inertiaVelocity = 0
                    offset -= speed * delta
                }

                renderTrack()
            }

            updateEffects()
            raf = requestAnimationFrame(animate)
        }

        const stride = getStride()
        offset = -(slides.length * 2 * stride)

        renderTrack()
        updateEffects()
        raf = requestAnimationFrame(animate)

        return () => {
            cancelAnimationFrame(raf)
        }
    }, [])

    return (
        <div ref={viewportRef} className={c.component}>
            <ul ref={trackRef} className={c.list}>
                {loopSlides.map((slide, index) => (
                    <li
                        key={index}
                        className={c.item}
                    >
                        <img src={slide} alt="Slide" />
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default Slider
